export class SteuerDetails {
    // BT-116
    gesamtsummeNetto = 0
    // BT-117
    umsatzsteuerbetrag = 0
    // BT-118
    umsatzsteuerCode = "S"
    // BT-119
    umsatzsteuersatz = 0
    // BT-120
    befreiungsgrund = ""
    // BT-121
    befreiungsgrundCode = ""

    get notEmpty(): boolean {
        return (
            this.gesamtsummeNetto !== 0 ||
            this.umsatzsteuerbetrag !== 0 ||
            this.umsatzsteuerCode.trim().length > 0 ||
            this.umsatzsteuersatz !== 0 ||
            this.befreiungsgrund.trim().length > 0 ||
            this.befreiungsgrundCode.trim().length > 0
        )
    }

    toJSON() {
        return {
            gesamtsummeNetto: this.gesamtsummeNetto,
            umsatzsteuerbetrag: this.umsatzsteuerbetrag,
            umsatzsteuerCode: this.umsatzsteuerCode,
            umsatzsteuersatz: this.umsatzsteuersatz,
            befreiungsgrund: this.befreiungsgrund,
            befreiungsgrundCode: this.befreiungsgrundCode,
        }
    }
}
